<span class="icon" data-bs-toggle="tooltip" ngbTooltip="{{toolTip}}" placement="{{placement}}"
  (click)="onClickEvent($event)">
  @if (!loadingIcon && iconSrc) {
  <img src="{{iconSrc}}" alt="" />
  }
  @if (!loadingIcon && faIcon) {
  <span>
    <fa-icon [icon]="faIcon"></fa-icon>
  </span>
  }
  @if (!loadingIcon && text) {
  <span>
    {{text}}
  </span>
  }
  @if (loadingIcon) {
  <fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>
  }
</span>